import React from 'react';
import { useState } from 'react';
import Menu from '../components/Menu.js';
import TextBlock from '../components/TextBlock.js';
import '../styles/index.css';
import '../styles/form.css';

export default function Info() {
	const [currency, setCurrency] = useState('');
	let text = require('../txt/InfoTxt.json');
	var num = 5;

	return(
		<div className="container text">
				<Menu />
			<div className="item">
				<div className="text-container ">
					<p>
						All the logistical details you need.
						Your photoshoot experience, above all, should be about you. 
						I'm here to invest back into you and want to accommodate as much as I can. 
						All packages can be tailored to best suit your needs. 
					</p>
					<p>
						Additions like extra film, analog videography, or set assistants are available to add-on in the contract. 
					</p>
					<p>
						Beginning 2024, all packages <em>must</em> include film photography add-on.
					</p>
					<p>
						Please select your location for correct pricing.
					</p>
					<form id="currency-form">
						<div> 
							<p>HONG KONG</p>
							<input 
								type="radio" 
								name="currency"
								id="HKD"
								onChange={function (e) {
				                	setCurrency(e.currentTarget.id);
				                }}
							/>
						</div>
						<div>
							<p>SINGAPORE</p>
							<input 
								type="radio" 
								name="currency"
								id="SGD" 
								onChange={function (e) {
				                	setCurrency(e.currentTarget.id);
				                }}
							/>
						</div>
						<div>
							<p>AUSTRALIA</p>
							<input 
								type="radio" 
								name="currency"
								id="AUD" 
								onChange={function (e) {
				                	setCurrency(e.currentTarget.id);
				                }}
							/>
						</div>
						<div>
							<p>UNITED KINGDOM</p>
							<input 
								type="radio" 
								name="currency"
								id="GBP" 
								onChange={function (e) {
				                	setCurrency(e.currentTarget.id);
				                }}
							/>
						</div>
						<div>
							<p>UNITED STATES</p>
							<input 
								type="radio" 
								name="currency"
								id="USD" 
								onChange={function (e) {
				                	setCurrency(e.currentTarget.id);
				                }}
							/>
						</div>
					</form>
				</div>
				{text.map((elt) => {
					if (currency != '') {
						num += 1;
						return (<div>
							<div className="text-container">
								<TextBlock
									subtitle={elt.subtitle}
									mainText={elt.mainText}
								/>
								{elt.subtext.map((x) => {return(<p>{x}</p>)})}
								<br />
								<p>STARTING AT <span className="loc_price">{elt.price[currency]} {currency}</span></p>
								<br />
							</div>
							<div className="flower-container">
								<img 
									alt={'bitmap flower'}
									src={require('/public/flowers/' + num + '.png')}
									className={'flower'}
								/>
							</div>
						</div>);
					}
					else {
						num += 1;
						return (<div>
							<div className="text-container">
								<TextBlock
									subtitle={elt.subtitle}
									mainText={elt.mainText}
								/>
								{elt.subtext.map((x) => {return(<p>{x}</p>)})}
								<br />
							</div>
							<div className="flower-container">
								<img 
									alt={'bitmap flower'}
									src={require('/public/flowers/' + num + '.png')}
									className={'flower'}
								/>
							</div>
						</div>);
					}
				})}
				<div id="video">
					<video width="100%" height="auto" autoplay loop controls muted>
						<source src={require('../vid/vid-1.mp4')} type="video/mp4" />
					</video>
				</div>
				<a href={`/contact`}><div id="contact-button">
					<p>BOOK YOUR SHOOT</p>
				</div></a>
				<div>
					<a href="https://instagram.com/erye.film" target="_blank" className="ig-icon">
						<img 
							alt={'Instagram logo'}
							src={require('../img/ig.png')}
						/>
					</a>
				</div>
			</div>
		</div>
	);
}